import { render } from "./AddOrder.vue?vue&type=template&id=fdd4dabe&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"

import "./AddOrder.vue?vue&type=style&index=0&id=fdd4dabe&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd4dabe"]])

export default __exports__